import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import serviceService from './serviceService';
import { toast } from 'react-toastify';

const initialState = {
  services: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: '',
};

// Yeni hizmet oluştur (Async Thunk)
export const createService = createAsyncThunk(
  'services/create',
  async (serviceData, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.userInfo.token;
      toast.success('Proje başarıyla oluşturuldu!');
      return await serviceService.createService(serviceData, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Tüm hizmetleri getir (Async Thunk)
export const getServices = createAsyncThunk(
  'services/getAll',
  async (_, thunkAPI) => {
    try {
      return await serviceService.getServices();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Hizmet güncelle (Async Thunk)
export const updateService = createAsyncThunk(
  'services/update',
  async ({ id, serviceData }, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.userInfo.token;
      toast.success('Proje başarıyla güncellendi!');
      return await serviceService.updateService(id, serviceData, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Hizmet sil (Async Thunk)
export const deleteService = createAsyncThunk(
    'services/delete',
    async (id, thunkAPI) => {
      try {
        const token = thunkAPI.getState().auth.userInfo.token;
        toast.success('Proje başarıyla silindi!');
        return await serviceService.deleteService(id, token);

      } catch (error) {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        return thunkAPI.rejectWithValue(message);
      }
    }
  );

export const serviceSlice = createSlice({
  name: 'service',
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(createService.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.services.push(action.payload);
      })
      .addCase(createService.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getServices.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getServices.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.services = action.payload;
      })
      .addCase(getServices.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(updateService.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        // State'deki hizmet listesini haritala, güncellenen hizmeti bul ve yenisiyle değiştir.
        state.services = state.services.map((service) =>
          service.id === action.payload.id ? action.payload : service
        );
      })
      .addCase(updateService.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(deleteService.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        // action.payload'un { id: '...' } şeklinde bir nesne olduğunu varsayıyoruz.
        // Gelen ID'yi sayıya çevirip karşılaştırıyoruz.
        state.services = state.services.filter(
          (service) => service.id !== Number(action.payload.id)
        );
      })
      .addCase(deleteService.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

// reset action'ını ve reducer'ı doğru şekilde export et
export const { reset } = serviceSlice.actions;
export default serviceSlice.reducer;